import * as ApiManager from './_manager';
import store from '@/store';

export const revenue = {
  listByScreenings: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/revenue/listByScreenings`,
      payload
    );
  },
  listByFilms: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/revenue/listByFilms`,
      payload
    );
  },
  list: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/revenue/list`,
      payload
    );
  },
  getSummary: payload => {
    let company_id = payload.company_id ? payload.company_id : store.getters['company/getSelected'];
    return ApiManager.callApi (
      `/member/company/${company_id}/revenue/getRevenueSummary`,
      payload
    );
  },
  requestPayout: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/revenue/requestPayout`,
      payload
    );
  },
};
